import { useSessionStore } from "../../../stores/UserStore";
import { Stack } from "@mantine/core";
import {
  IconAddressBook,
  IconHelp,
  IconSettings,
  IconSpeakerphone,
  IconTimelineEvent,
} from "@tabler/icons-react";

export function getKnowledgesDE() {
  const reseller = useSessionStore.getState().reseller;

  const result = [
    {
      url: "contact-lists",
      icon: IconAddressBook,
      title: "Kontaktlisten",
      desc: "Alles Wissenswerte über Kontaktlisten",
      items: [
        {
          url: "filters",
          title: "Meine Kontakte in einer Liste filtern",
          content: (
            <Stack>
              <p>
                Sobald Ihre Liste erstellt ist, haben Sie die Möglichkeit, Ihre
                Liste zu sortieren. Wenn sie Ihnen nicht zusagt oder Sie sie
                filtern möchten, können Sie Kontakte ausschließen. <br />
              </p>
              <p>
                Auf der Seite Kontakte können Sie auf den Namen Ihrer Liste
                klicken und Sie sehen die Details Ihrer Liste.
                <br />
              </p>
              <p>
                Sie finden insbesondere über Ihrer Liste ein Symbol „Filter“,
                mit dem Sie Kontakte aus Ihrer Liste ausschließen können,
                <br />
              </p>
              <p>
                Zum Beispiel: Ich möchte alle Kontakte löschen, deren „Funktion“
                „Assistent“ enthält.{" "}
              </p>
            </Stack>
          ),
        },
        {
          url: "page",
          title: "Funktionen der Kontaktseite",
          content: (
            <Stack>
              <p>
                Der Tab „Liste“ ermöglicht es Ihnen, alle Ihre Kontaktlisten
                wiederzufinden, um Ihre Akquisekampagnen durchzuführen.
                <br />
                <br />
              </p>
              <p>
                Dort finden Sie alle Funktionen und Werkzeuge für eine gute
                Verwaltung Ihrer Kontaktlisten
                <br />
              </p>
              <ul>
                <li>
                  Erstellung einer Liste aus unserer B2B-Kontaktdatenbank
                  <br />
                </li>
                <li>Erstellung einer Liste aus LinkedIn</li>
                <li>Erstellung Ihrer Listen aus Google</li>
                <li>Import Ihrer Listen</li>
              </ul>

              {/* Image here */}

              <p>
                <b>
                  ORDNERANSICHT
                  <br />
                </b>
              </p>
              <ul>
                <li>
                  Alle Listen anzeigen
                  <br />
                </li>
                <li>Einen Ordner erstellen</li>
                <li>Einen Ordner umbenennen</li>
                <li>Einen Ordner löschen</li>
                <li>Einen Ordner suchen</li>
              </ul>
              <p>
                <b>
                  <br />
                  SPALTE ''AKTION''
                  <br />
                  Button ''Stift'' können Sie:
                </b>
              </p>
              <ul>
                <li>Ihre Liste umbenennen</li>
                <li>Tags hinzufügen</li>
                <li>Ihre Liste erstellen und in einen Ordner verschieben</li>
              </ul>
              <p>
                <br />
              </p>
              <p></p>
              <p>
                <b>Button ''+'' können Sie:</b>
                <br />
              </p>
              <ul>
                <li>Die Kontakte Ihrer Liste in einem neuen Tab sehen</li>
                <li>Eine Kontaktliste aus einer Datei importieren</li>
                <li>Eine Kontaktliste per Kopieren-Einfügen importieren</li>
                <li>Ihre Datei als CSV oder XLSX herunterladen</li>
                <li>Ihre Liste duplizieren</li>
                <li>
                  Eine Liste an einen Benutzer, ein Team, ein Unternehmen
                  kopieren
                </li>
                <li>Ihre Liste ins PRM kopieren</li>
                <li>Ihre Liste in X Listen teilen (Splitter)</li>
              </ul>
              <p>
                <br />
              </p>
              <p>
                <b>Button ''Papierkorb''</b>
                <br />
              </p>
              <ul>
                <li>Ihre Liste löschen</li>
              </ul>
              <p>
                <br />
                <b>INFO </b>: Sie können mehrere Listen auswählen, um
                gleichzeitig eine der Aktionen durchzuführen
              </p>

              {/* Image here */}

              <p>
                <b>SPALTE "AKTION"</b>
              </p>
              <ul>
                <li>Ihre Kontakte als CSV oder XLSX herunterladen</li>
                <li>
                  Die Auswahl Ihrer Kontakte in eine neue Liste duplizieren
                </li>
                <li>
                  Eine Liste an einen Benutzer, ein Team, ein Unternehmen
                  kopieren
                </li>
                <li>
                  Ihre Kontaktauswahl an einen Benutzer, ein Team, ein
                  Unternehmen kopieren
                </li>
                <li>Ihre Kontaktauswahl ins PRM kopieren</li>
                <li>Ihre Kontaktauswahl in X Listen teilen (Splitter)</li>
              </ul>
              <p>
                <br />
              </p>
              <p>
                <b>Button ''Papierkorb''</b>
              </p>
              <ul>
                <li> Ihre Liste löschen</li>
              </ul>
              <p></p>
              <p></p>

              {/* Image here */}

              <p>
                <b>
                  Symbolleiste für den Schnellzugriff
                  <br />
                </b>
              </p>
              <ul>
                <li>In einer Liste oder den Ordnern suchen</li>
                <li>Multikriterien-Suchfilter mit Bedingungen</li>
                <li>Verwaltung der Spaltenanzeige</li>
                <li>Eine Liste oder einen Ordner exportieren</li>
                <li>Eine Liste oder einen Ordner löschen</li>
              </ul>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "configurations",
      icon: IconSettings,
      title: "Konfigurationen",
      desc: "Die Akquise-Software konfigurieren",
      items: [
        {
          url: "add-exclusions",
          title: "Ihre Abmelde- oder Blacklists erstellen",
          content: (
            <Stack>
              <p>
                Auf der Plattform haben Sie die Möglichkeit, Kontakte von Ihren
                Kampagnen auszuschließen.
                <br />
                <br />
                So erhalten sie Ihre Nachrichten nicht und werden automatisch
                von Ihren Kampagnen / Szenarien ausgeschlossen.
                <br />
                <br />{" "}
              </p>
              <p>
                Dies ist ein Vorsichtsprinzip, um Ihre Interessenten, Kunden,
                Partner, Lieferanten usw. nicht zu kontaktieren, ohne jeden
                Kontakt Ihrer Liste vor dem Versand Ihrer Kampagne manuell
                prüfen zu müssen.
                <br />
                <br />
              </p>
              <p>Dazu genügt es:</p>
              <p>
                {" "}
                Eine Kontaktliste als CSV-Datei hier zu importieren{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/exclusions/blacklists`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /exclusions/blacklists.
                  <br />
                </a>
                ODER auf den Tab „Konfiguration“ &gt; „Blacklist“ &gt;
                „Importieren“ einer auszuschließenden Kontaktliste zu klicken.{" "}
                <br />
                <br />
                Sie können auch Ordner Ihrer auszuschließenden Listen nach
                Ausschlusstypologie erstellen, wie Ihre Kunden, Personen, die
                niemals kontaktiert werden sollen...
                <br />
                <br />
              </p>
              <p>
                Die vom System berücksichtigten Abmeldeschlüssel sind: E-Mail,
                Domainname, SIRET, SIREN, LinkedIn-Link oder der Firmenname.
                <br />
                <br />
              </p>
              <p>
                <b>Um Kontakte dauerhaft abzumelden</b>, müssen Sie auf diese
                Seite gehen:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/exclusions/unsubscribers`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /exclusions/unsubscribers
                </a>{" "}
                .<br />
                Oder auf den Tab „Konfiguration“ &gt; „Liste der Abgemeldeten“
                klicken
                <br />
                <br />
              </p>
              <p>
                <b>Achtung</b>: Die Datei darf nur eine Information pro Zeile
                enthalten. <br />
                Diese Informationen können in Ihrer Importdatei gemischt sein.
                <br />
                <b>
                  <br />
                </b>
              </p>
              <p>
                <b>
                  Der Unterschied zwischen einer Ausschlussliste und einer
                  Abmeldung:
                  <br />
                  <br />
                </b>
              </p>
              <p>
                {" "}
                <b>Die Abmeldung </b>ist automatisch und unumkehrbar: Sobald der
                Kontakt als abgemeldet markiert ist, können Sie sicher sein,
                dass er nichts mehr von Ihnen erhalten wird.
                <br />
                <br />
              </p>
              <p>
                {" "}
                <b>Die Ausschlussliste</b> wird bei jeder Kampagne ausgewählt,
                je nachdem, ob Sie sie bei jedem Versand berücksichtigen möchten
                oder nicht.
              </p>
            </Stack>
          ),
        },
        {
          url: "connect-email",
          title: "Mein E-Mail-Konto verbinden",
          content: (
            <Stack>
              <p>
                Bevor Sie eine E-Mail-Kampagne starten, müssen Sie auf die
                Versandmethode und die gewählte Absender-E-Mail achten.
              </p>
              <p>Sie haben somit zwei Alternativen:</p>
              <ol>
                <li>
                  {" "}
                  Massenversand (Mass Mailing): Dies ermöglicht den Versand von
                  Kampagnen an große Volumen und schnell, aber mit einer
                  geringeren Öffnungsrate.
                  <br />
                  Die Sendungen (Routing) erfolgen über die
                  {reseller?.name}-Plattform. Sie haben die Möglichkeit, beim
                  Versand einen Alias zu konfigurieren. Ein Alias (Artefakt) ist
                  die E-Mail, die Ihre Interessenten sehen werden, die aber beim
                  Versand nicht verwendet wird.
                  <br />
                  <b>Achtung</b>, {reseller?.name} wird bei Ihren
                  Massenversand-Sendungen niemals erscheinen
                </li>
                <li>
                  {" "}
                  Versand aus Ihrem E-Mail-Postfach: Dies ermöglicht es, Ihre
                  Antwortraten zu erhöhen, indem Sie mit jedem Interessenten auf
                  individueller Ebene kommunizieren.
                </li>
              </ol>
              <p>
                {" "}
                Sie können Ihre E-Mail-Postfächer mit der Plattform verbinden.
                Sie können beim Versand der Kampagne die gesendeten E-Mails in
                Ihrem Tab „Gesendete E-Mails“ in Ihrem E-Mail-Postfach sehen.{" "}
              </p>
              <p>
                Achtung, wir empfehlen, die Sendungen auf 100 E-Mails / Tag pro
                Absender-E-Mail zu beschränken.
                <br />
                <br />
              </p>
              <p>
                <b>
                  Um Ihre E-Mails zu konfigurieren, laden wir Sie ein, auf den
                  Link zu klicken:{" "}
                </b>
              </p>
              <p>
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/senders/email`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /senders/email
                </a>{" "}
                oder gehen Sie zum Tab „Werkzeug“ &gt; Absender-E-Mails
              </p>
              <p>Sie haben zwei Möglichkeiten:</p>
              <ol>
                <li>
                  {" "}
                  Klicken Sie auf „Fügen Sie Ihre E-Mail als Absender hinzu“
                  (blauer Button), was dem Hinzufügen eines Massenversand-Alias
                  entspricht.
                  <br />- Geben Sie Ihre E-Mail-Adresse ein und bestätigen Sie
                  mit „Speichern“. Sie erhalten eine Bestätigungs-E-Mail in Ihr
                  Postfach, um sicherzustellen, dass Ihnen die Domain gehört.
                </li>
                <li>
                  {" "}
                  Klicken Sie auf „Senden Sie Ihre E-Mail von Ihrer SMTP-Domain“
                  (grüner Button), was der Verbindung Ihres E-Mail-Postfachs
                  entspricht.
                </li>
              </ol>
              <p>
                {" "}
                Wenn sich das Pop-up öffnet, wählen Sie den Anbieter Ihres
                E-Mail-Kontos aus
              </p>
              <ul>
                <li>
                  Für Gmail oder Outlook wählen Sie die E-Mail-Adresse aus, die
                  Sie hinzufügen möchten, und folgen Sie den nächsten Schritten.
                </li>
                <li>
                  Für andere E-Mail-Anbieter füllen Sie die angeforderten
                  Informationen aus.
                  <br />
                  <br />
                </li>
              </ul>
              <p>
                <b>Zusätzliche Konfiguration:</b>
              </p>
              <p>
                Diese Optionen ermöglichen es Ihnen, den korrekten Empfang Ihrer
                E-Mails zu optimieren:
              </p>
              <ul>
                <li> Abmeldelink aktivieren / deaktivieren.</li>
                <li>
                  {" "}
                  Tracking von Öffnern/Klickern aktivieren / deaktivieren.
                </li>
                <li>
                  {" "}
                  Versandfrequenzen: Zeitspanne zwischen zwei E-Mail-Sendungen.
                </li>
                <li>
                  {" "}
                  Warm UP: Aufwärmen einer E-Mail (Technik zur Bewahrung der
                  IP-Reputation).
                </li>
                <li>
                  {" "}
                  SMTP-Pool: Möglichkeit, Ihre Absender-E-Mails mit einem
                  SMTP-Pool zu verknüpfen.
                </li>
              </ul>
            </Stack>
          ),
        },
        {
          url: "email-validation",
          title: "Validierung einer E-Mail",
          content: (
            <Stack>
              <p>
                <i>
                  <b>Frage </b>: Ich habe die Bestätigungsmail für das
                  Hinzufügen eines E-Mail-Kontos erhalten von:{" "}
                  <a
                    href={`http://${
                      reseller?.domain_saas3 || reseller?.domain_saas2
                    }`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {reseller?.domain_saas3 || reseller?.domain_saas2}
                  </a>{" "}
                  info@{reseller?.domain_saas3 || reseller?.domain_saas2}, was
                  mir anormal erscheint.
                </i>
              </p>
              <br />
              <p>
                <b>Antwort </b>: Dies ist kein Fehler, da die Validierung eines
                neuen Kontos (Systemverfahren) von der Plattform{" "}
                <b>{reseller?.name}</b> stammt.
                <br />
              </p>
              <p>
                Um einen personalisierten Absender für die Warnungen oder
                Validierungen der Software zu haben, müssen Sie den Tarif
                wechseln, um zu White Label zu wechseln.
                <br />
              </p>
              <p>Bitte kontaktieren Sie diesbezüglich den Vertrieb</p>
            </Stack>
          ),
        },
        {
          url: "create-signature",
          title: "Ihre E-Mail-Signaturen erstellen",
          content: (
            <Stack>
              <p>
                Wenn Sie eine E-Mail erstellen, können Sie dem Inhalt Ihre
                Signatur hinzufügen. <br />
              </p>
              <p>
                Dazu können Sie Ihre Signatur zuvor auf die Plattform
                importieren.
              </p>
              <p>
                Klicken Sie auf den Link{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/models/email-signature`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /models/email-signature
                </a>{" "}
                und klicken Sie dann auf den Button „Eine Signatur erstellen“
              </p>
              <p>
                Oder gehen Sie zum Tab „Konfigurationen“ &gt; E-Mail-Signaturen.
                <br />
              </p>
              <p>
                Sobald Ihre Signatur hinzugefügt ist, können Sie beim Ändern
                oder Erstellen Ihrer Szenariovorlage auf den Button „Signatur“
                klicken, um Ihre Signatur hinzuzufügen, indem Sie eine der
                bereits erstellten Signaturen auswählen. <br />
                <br />
              </p>
              <p>
                <b>INFO </b>: Bei der Erstellung Ihrer E-Mail-Nachrichten können
                Sie Ihre Nachricht dennoch mit der gewünschten Signatur vorab
                anzeigen
              </p>
              <p></p>
            </Stack>
          ),
        },
        {
          url: "dynamic-columns",
          title: "Dynamische Spalten",
          content: (
            <Stack>
              <p>
                Dynamische Spalten werden beim Import einer Kontaktliste
                verwendet, wenn die Spalten in Ihrer Datei von der Software
                nicht vorgesehen und erstellt wurden.
              </p>

              {/* Image here */}

              <p>
                Um diesen Mangel an Spalten auszugleichen, haben Sie beim Import
                Ihrer Datei die Möglichkeit, diese dynamischen Spalten zu
                erstellen.
                <br />
                <br />
              </p>
              <p>
                Für die Verwaltung dieser Spalten: Hinzufügen oder Löschen,
                können Sie hier hingehen:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/settings/tools/datafields`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /settings/tools/datafields
                </a>
              </p>
              <p>Oder im Tab „Konfigurationen“ -&gt; dynamische Spalten</p>
              <p>
                <br />
                In der Spalte „<b>Aktion</b>“ können Sie:{" "}
              </p>
              <p>
                <b>Löschen </b>: ermöglicht das Löschen der dynamischen Spalte.
              </p>
              <p>
                <br />
                <b>ACHTUNG </b>: Diese Aktion des Löschens einer dynamischen
                Spalte wird auch <b>ALLE DATEN</b> dieser <br />
                <br />
                Die Spalte „<b>Teilen</b>“ ermöglicht es Ihnen, diese Spalte mit
                Ihren Mitarbeitern, einem Team oder einem Unternehmen zu teilen.
              </p>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "campaigns",
      icon: IconSpeakerphone,
      title: "Kampagnen",
      desc: "Die Grundlagen zu Ihren Kampagnenversendungen",
      items: [
        {
          url: "statistics",
          title: "Statistiken Ihrer Kampagnen",
          content: (
            <Stack>
              <p>
                Auf der Plattform {reseller?.name} verfügen Sie über Statistiken
                Ihrer Kampagnen.
                <br />
              </p>
              <p>
                Auf Ihrem Dashboard finden Sie die Anzahl der gesendeten
                E-Mails, programmierter E-Mails, geklickter E-Mails, geöffneter
                E-Mails, erhaltener E-Mails.
                <br />
              </p>
              <p>
                Für LinkedIn-Kampagnen sind die zu verfolgenden KPIs die
                Annahmeraten Ihrer Einladungen (Beziehungsstufe 1), die
                Antwortraten und die Leseraten Ihrer Nachrichten
                (Beziehungsstufe 2 und 3).
                <br />
              </p>
              <p>
                Die Daten werden in Tabellenform dargestellt: So haben Sie
                Statistiken, die Ihre Kampagnen analysieren, organisiert
                Kampagne für Kampagne.
                <br />
              </p>
              <p>
                Klicken Sie auf den Link:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/statistics/campaigns`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /statistics/campaigns
                </a>
              </p>
              <p>Oder gehen Sie zum Tab „Kampagnen“</p>
              <p>
                <br />
                <b>In der Tabelle finden Sie:</b>
              </p>
              <ul>
                <li>
                  {" "}
                  Programmierte E-Mails: die Anzahl der E-Mails, die gerade
                  ausgeführt werden.
                </li>
                <li>
                  {" "}
                  Die Anzahl der gesendeten E-Mails aus den programmierten
                  E-Mails.
                </li>
                <li>
                  {" "}
                  Geöffnete E-Mails: Die Anzahl der E-Mails, die bei Empfang
                  geöffnet wurden.
                </li>
                <li>
                  {" "}
                  Geklickte E-Mails: die Anzahl der E-Mails, in denen es einen
                  Link gibt, auf den der Empfänger geklickt hat.
                </li>
                <li>
                  {" "}
                  Die Anzahl der erhaltenen Antworten nach dem Versand der
                  E-Mails.
                </li>
              </ul>
              <p>
                <br />
                Wenn Sie mehr Details wünschen und auf die täglichen
                Versandstatistiken zugreifen möchten, können Sie auf das Symbol
                „Bericht“ rechts neben jeder Ihrer Kampagnen im Statistik-Tab
                klicken.{" "}
              </p>
            </Stack>
          ),
        },
        {
          url: "view-campaigns",
          title: "Meine programmierten Kampagnen finden",
          disabled: true,
          content: (
            <Stack>
              <p>
                Sie haben die Möglichkeit, alle Ihre Kampagnen zu sehen, sobald
                sie programmiert sind, indem Sie auf den Tab „Kampagnen“
                klicken:
                <br />
              </p>
              <p>
                Sie können Ihre Kampagnen schnell filtern, indem Sie „Laufend,
                Pausiert, Fehler, Archiviert“ auswählen
                <br />
                <br />
                Sie können auch die Multikriterien-Filter über die Funktion
                „Filter“ verwenden
                <br />
              </p>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "leads-tracking",
      icon: IconAddressBook,
      title: "Lead-Verfolgung",
      desc: "Prospect Relationship Management",
      items: [
        {
          url: "general",
          title: "Lead-Verfolgung im Allgemeinen",
          disabled: true,
          content: (
            <Stack>
              <p>
                Für jede gesendete Kampagne erstellt das System einen Ordner auf
                der Plattform, in dem es Ihre aktiven Kontakte speichert: das
                ist das PRM (Prospect Relationship Management).
                <br />
              </p>
              <p>
                Man verwaltet ein PRM nicht wie ein CRM (Customer Relationship
                Management).
                <br />
              </p>
              <p>
                Aus einem recht einfachen Grund: Ein Kunde ist kein Interessent
                und wir sprechen einen Kunden nicht auf die gleiche Weise an wie
                einen Interessenten.
                <br />
              </p>
              <p>
                Die Beziehungsansätze und die daraus resultierenden Aktionen
                sind unterschiedlich!
              </p>
              <p>
                Im Gegensatz zu einem CRM ermöglicht das PRM, Follow-up-Aufgaben
                durch das Szenario zu automatisieren, den Interessenten in neue
                Akquise-Schleifen zu lenken, das Nurturing je nach seinem Status
                zu aktivieren: interessiert, noch nicht bereit...
                <br />
              </p>
              <p>
                So finden Sie in jedem Ordner die Interessenten jeder Kampagne
                unabhängig voneinander: Öffner, Klicker, Antworter, Personen,
                die Ihre LinkedIn-Einladung angenommen haben, Personen, die
                Ihnen auf LinkedIn geantwortet haben, usw.
                <br />
              </p>
              <p>
                Das PRM ist erreichbar unter{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/leads-tracking`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /leads-tracking
                </a>{" "}
              </p>
              <p>
                oder über den Tab „PRM“.
                <br />
              </p>
              <p>
                In jedem PRM-Ordner finden Sie so Ihre aktiven Kontakte,
                klassifiziert nach Status und in absteigender
                Scoring-Reihenfolge.
                <br />
              </p>
              <p>
                Sie können auch automatisch in Ihr CRM synchronisieren, nachdem
                Sie eine Synchronisation mit
                {reseller?.name} erstellt haben, oder Ihre aktiven Kontakte
                herunterladen und direkt in Ihrem CRM bearbeiten
              </p>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "workflows",
      icon: IconTimelineEvent,
      title: "Szenario",
      desc: "Alles über Szenarien",
      items: [
        {
          url: "create-email",
          title: "Ein Szenario erstellen",
          content: (
            <Stack>
              <p>
                Auf der Plattform können Sie Szenarien erstellen, die eine
                Abfolge von Aktionen darstellen, die unter vordefinierten
                Bedingungen ausgelöst werden.
                <br />
                <br />
              </p>
              <p>
                Um ein neues Szenario zu erstellen, laden wir Sie ein, auf
                diesen Link zu gehen:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/campaign/create`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /campaign/create
                  <br />
                  <br />
                </a>
              </p>
              <p>
                Oder gehen Sie zum Tab „Meine Szenarien“ &gt; Ein neues Szenario
                erstellen &gt; Einen Szenarionamen hinzufügen.
                <br />
                <br />
              </p>
              <p>Hier ist das Verfahren, um ein Szenario zu erstellen:</p>
              <ol>
                <li>
                  Wählen Sie den gewünschten Kanal aus LinkedIn / E-Mail / SMS /
                  Sprachnachricht.
                </li>
                <li>
                  {" "}
                  Erste Nachricht: Fügen Sie Ihre Akquise-Nachricht Ihrem
                  Szenariobaum hinzu, indem Sie auf das kleine Plus unter der
                  ursprünglichen Aktion klicken.
                </li>
                <li>
                  {" "}
                  Follow-up: Wählen Sie den Kanal, über den Sie das Follow-up
                  durchführen möchten.
                </li>
                <li>
                  {" "}
                  Wählen Sie die Population aus, die Ihr Follow-up erhalten soll
                  (Öffner, Klicker, Nicht-Aktive, Personen, die Ihre Einladung
                  auf LinkedIn angenommen haben usw.) und die Frist, innerhalb
                  derer Ihr Follow-up versendet wird.
                </li>
                <li>
                  {" "}
                  Fügen Sie den Inhalt Ihrer Follow-up-Nachrichten hinzu.
                </li>
                <li>
                  {" "}
                  Speichern Sie Ihr Szenario.
                  <br />
                  <br />
                </li>
              </ol>
              <p>
                <b>Achtung</b>, stellen Sie sicher, dass Sie zuvor Ihre
                verschiedenen Nachrichten unter dem Link erstellt haben:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/models/email`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /models/email
                </a>{" "}
                oder indem Sie zum Tab „Meine E-Mail-Vorlagen“ gehen
              </p>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "faq-guides-questions",
      icon: IconHelp,
      title: "FAQ, LEITFÄDEN & FRAGEN",
      desc: "Häufig gestellte Fragen zur Anwendung",
      items: [
        {
          url: "smtp-limit",
          title: "SMTP-Limit erreicht",
          content: (
            <Stack>
              <p>
                <b>Frage </b>:{" "}
                <i>
                  Ich versuche gerade, neue Absender-E-Mails einzugeben, und
                  wenn ich am Ende der Eingabe ankomme, erscheint eine
                  Fehlermeldung, die mir sagt: SMTP-LIMIT erreicht
                </i>
              </p>

              <br />
              <p>
                <b>Antwort </b>: Sie haben die maximale Anzahl an Konten
                erreicht, die in die Software integriert werden können.
              </p>
              <p>
                Sie müssen das Kontenlimit Ihres Angebots überprüfen.
                <br />
              </p>
              <p>
                Wenn Sie mehr SMTP-Konten wünschen, wechseln Sie bitte zu einem
                höheren Angebot
              </p>
            </Stack>
          ),
        },
        {
          url: "edit-sender-name",
          title: "Wie ändert man den Absendernamen?",
          content: (
            <Stack>
              <p>
                <b>Frage </b>:{" "}
                <i>
                  Wenn ein Interessent auf eine E-Mail antwortet, erhalte ich
                  diese E-Mail von „Nicolas von {reseller?.name}“. Wie kann man
                  den Absendernamen ändern?
                </i>
              </p>
              <br />
              <p>
                <b>Antwort </b>: Wenn Sie Ihre E-Mail hier erstellen/ändern:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/models/email`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /models/email
                </a>
                <br />
                <br />
              </p>
              <p>
                Rechts neben dem Feld „Antwort-E-Mail“ haben Sie ein „+“, das
                Ihnen erlaubt, die Antwortoption zu wählen
                <br />
              </p>
              <ol>
                <li>
                  ==&gt; Option 01: Sie erhalten die E-Mail direkt, als ob Ihr
                  Interessent Ihnen direkt antworten würde, ohne dass die
                  Antwort über unsere Plattform läuft. In diesem Fall haben Sie
                  nicht mehr die gemeldeten Probleme, aber wir können die
                  erhaltene Antwort nicht innerhalb unserer Plattform speichern
                  <br />
                  <br />
                </li>
                <li>
                  ==&gt; Option 02: (die derzeit ausgewählte) Wenn der
                  Interessent antwortet, antwortet er unserem Server, der Ihnen
                  die E-Mail weiterleitet, weshalb „Nicolas von {reseller?.name}
                  “ erscheint. Diese Lösung ermöglicht es uns, die Antwort des
                  Interessenten innerhalb der Plattform zu speichern.
                  <br />
                  <br />
                </li>
              </ol>
              Mit dieser Lösung ist es besser, sobald Sie die Antwort erhalten,
              ein neues Gespräch zu eröffnen, um den Austausch mit Ihrem
              Interessenten fortzusetzen.
            </Stack>
          ),
        },
        {
          url: "checkout-failed",
          title: "Warum schlägt meine Kartenzahlung fehl?",
          content: (
            <Stack>
              <p>
                Wir verwenden ein sicheres Zahlungssystem (3D Secure), das von
                der ACPR unter der Nummer 16568 zugelassen ist, um Ihre Einkäufe
                zu schützen.
                <br />
                <br />
              </p>
              <p>
                Überprüfen Sie den Empfang einer SMS, um Ihren Kauf zu
                bestätigen. <br />
                Wenn das Problem weiterhin besteht, kontaktieren Sie uns.
              </p>
            </Stack>
          ),
        },
        {
          url: "segment-contact-list",
          title: "Ist es möglich, meine Kontaktlisten zu segmentieren?",
          content: (
            <Stack>
              <p>
                <b>Ja, </b>indem Sie so viele Akquise-Kontaktlisten erstellen,
                wie Sie möchten.
                <br />
                <br />
              </p>
              <p>
                Dank unserer intelligenten Filter können Sie die Suchfilter
                kombinieren: Funktion, Tätigkeitsbereich, NAF-Code,
                Mitarbeiterzahl, Umsatz, Anrede, Interessenschwerpunkt,
                Kompetenzzentrum…
                <br />
                <br />
              </p>
              <p>
                Wenn Ihnen ein Filter unter unseren 20 Filtern fehlt, zögern Sie
                nicht, uns danach zu fragen.
              </p>
            </Stack>
          ),
        },
        {
          url: "database-reactive",
          title: "Ist Ihre Kontaktdatenbank reaktiv?",
          content: (
            <Stack>
              <p>
                <b>Ja</b>, da unsere Datenbanken beim Versand von E-Mailings für
                unsere Kunden getestet werden.
                <br />
              </p>
              <p>
                Dank der Tracker, die wir beim Versand in unsere E-Mails
                einfügen, ist es uns möglich zu kontrollieren, ob der
                Interessent sein E-Mail-Postfach öffnet.
                <br />
              </p>
              <p>
                Wenn ein Interessent sein E-Mail-Postfach innerhalb eines Monats
                nicht öffnet, isolieren wir diesen Kontakt, um ihn nicht mehr zu
                kontaktieren.
                <br />
              </p>
              <p>
                Dies ermöglicht es uns, über eine reaktive B2B-Kontaktdatenbank
                zu verfügen.
                <br />
              </p>
            </Stack>
          ),
        },
        {
          url: "is-it-french",
          title: "Ist Ihre Lösung in Frankreich entwickelt?",
          content: (
            <Stack>
              <p>
                <b>Ja</b>, unsere Lösung ist 100% französisch
                <br />
              </p>
              <ul>
                <li> Sie wird in Frankreich entwickelt</li>
                <li>
                  {" "}
                  Sie wird auf sicheren Servern in Frankreich bei OVH gehostet
                </li>
                <li>
                  {" "}
                  Alle Daten von {reseller?.name} und unseren Kunden werden auf
                  sicheren Servern in Frankreich gespeichert
                </li>
              </ul>
            </Stack>
          ),
        },
        {
          url: "what-is-your-data-sources",
          title: "Was sind die Quellen Ihrer Dateien",
          content: (
            <Stack>
              <p>
                Die Hauptquellen unserer professionellen B2B-Datenbank stammen
                aus Dateien, die bereits von spezialisierten
                Branchenverzeichnissen und Marktführern in ihren Bereichen
                zusammengestellt wurden:
                <br />
              </p>
              <ul>
                <li> Die öffentlichen Daten der sozialen Netzwerke</li>
                <li>
                  {" "}
                  Die Datenbank mit rechtlichen Informationen von INSEE,
                  Infogreffe, Bodacc, Legi France, RNCS…
                </li>
                <li>
                  {" "}
                  Von der CCI: Das Portal der Industrie- und Handelskammern
                </li>
                <li> Das offizielle Verzeichnis der Handwerker</li>
                <li>
                  {" "}
                  Frei zugängliche Verzeichnisse: Vérif.com, Societe.com,{" "}
                  <a
                    href={`http://Kompass.fr`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Kompass.fr
                  </a>{" "}
                  …
                </li>
                <li>
                  {" "}
                  OpenData-Dateien von öffentlichen Verwaltungen, Gesundheit,
                  Bildung, Verbänden…
                </li>
              </ul>
            </Stack>
          ),
        },
        {
          url: "database-constitution",
          title: "Wie ist Ihre B2B-Kontaktdatenbank aufgebaut?",
          content: (
            <Stack>
              <p>
                Dank unserer Skripte und unserer intelligenten Algorithmen
                aggregieren wir alle
              </p>
              <p>
                Tage mehr als 20 Quellen qualifizierter beruflicher Dateien.
                <br />
              </p>
              <p>
                Die Profile unserer B2B-Basis werden täglich strukturiert,
                zusammengeführt, angereichert und erneut überprüft.
              </p>
            </Stack>
          ),
        },
        {
          url: "does-it-follow-rgpd-guidelines",
          title: "Entspricht Ihre Lösung der DSGVO-Verordnung?",
          content: (
            <Stack>
              <p>
                <b>Ja</b>, unsere Lösung entspricht der DSGVO
                (Datenschutz-Grundverordnung).
                <br />
              </p>
              <p>
                Es handelt sich um eine Verordnung, die vom Europäischen
                Parlament am 14. April 2016 angenommen wurde und am 24. Mai 2018
                in der Europäischen Union in Kraft trat.
                <br />
              </p>
              <ul>
                <li>
                  Unsere Datenbank besteht aus Informationen, die wir aus mehr
                  als 20 Quellen qualifizierter beruflicher Dateien und aus
                  Open-Data sowie Insee-Daten sammeln, die wir durch unsere
                  intelligenten Algorithmen aggregieren und strukturieren.
                </li>
                <li>
                  {" "}
                  Wir arbeiten nur mit B2B-Daten, die nicht der vorherigen
                  Einwilligung unterliegen, wie es Artikel 6 der CNIL durch die
                  e-Privacy-Richtlinie, die Vorrang vor der DSGVO hat,
                  vorschreibt und in französisches Recht umgesetzt wurde.
                </li>
                <li>
                  {" "}
                  Wir respektieren die Verpflichtung, einen Abmeldelink in jede
                  Kampagne unserer Kunden einzufügen.
                </li>
                <li>
                  {" "}
                  Wenn der Kunde vergisst, einen Abmeldelink einzufügen, oder
                  dieser falsch geschrieben ist, erkennt unser System dies und
                  fügt AUTOMATISCH einen klaren Abmeldelink am Ende der Seite
                  hinzu.
                </li>
                <li>
                  {" "}
                  Den Internetnutzer über die Informationen, die wir besitzen,
                  über den Ursprung der Sammlung sowie über die Löschung seiner
                  Informationen, die wir besitzen, zu informieren.
                </li>
                <li>
                  {" "}
                  Wir können auch die E-Mail, die Domain oder die SIREN-Nummer
                  von Unternehmen ausschließen, die dies verlangen, um sie nicht
                  mehr zu kontaktieren.
                </li>
                <li>
                  {" "}
                  Jeder Kunde kann seine Listen (MD5-Verschlüsselung) mit
                  Kontakten, Domains oder SIRENs importieren, die von Ihren
                  Kampagnen ausgeschlossen werden sollen.
                </li>
              </ul>
            </Stack>
          ),
        },
      ],
    },
  ];

  if (reseller?.name === "Magileads") {
    result[0].items.unshift(
      {
        url: "import-linkedin",
        title: "Eine Liste aus LinkedIn erstellen",
        content: (
          <Stack>
            <p>
              Mit {reseller?.name} können Sie Kontaktlisten aus einer Suche auf
              LinkedIn oder Sales Navigator erstellen. Sie müssen daher über ein
              LinkedIn-Konto verfügen.
              <br />
            </p>
            <p>
              Das Prinzip ist einfach: Von Ihrem LinkedIn-Konto aus führen Sie
              eine Kontaktsuche auf der LinkedIn-Website durch und
              kopieren/einfügen den Link Ihrer Suche auf der
              {reseller?.name}-Plattform.
              <br />
            </p>
            <p>
              So erstellt das System eine Liste von Kontakten, die den Profilen
              entsprechen, die Sie auf LinkedIn angesprochen haben.
              <br />
            </p>
            <p>
              Um den Import Ihrer LinkedIn-Kontakte durchzuführen, klicken Sie
              auf den Link:{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists/import/linkedin`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists/import/linkedin
              </a>{" "}
              und klicken Sie dann auf Suche auf LinkedIn
            </p>
            <p>Oder gehen Sie zum Tab „Kontakt“ &gt; Suche auf LinkedIn</p>
            <p>Sie haben somit mehrere Möglichkeiten: </p>
            <b>
              {" "}
              Kontakte aus einer LinkedIn/Sales Navigator-Suche extrahieren,
              indem Sie die folgenden Schritte ausführen:
              <br />
            </b>
            <ol>
              <li>
                {" "}
                Führen Sie Ihre Suche auf LinkedIn/Sales Navigator durch.{" "}
              </li>
              <li>
                {" "}
                Kopieren Sie den URL-Link Ihrer Suchseite auf LinkedIn oder
                Sales Navigator.
              </li>
              <li>
                {" "}
                Fügen Sie ihn in den Abschnitt „LinkedIn-URL der Suche“ ein &gt;
                Weiter.
              </li>
              <li>
                {" "}
                Wählen Sie die Anzahl der zu extrahierenden Profile, die größer
                oder gleich der Anzahl der am Ende Ihrer Suche gefundenen
                Kontakte sein muss &gt; Weiter.
              </li>
              <li>
                {" "}
                Wählen Sie das LinkedIn-Konto aus, mit dem Sie die Kontakte
                extrahieren möchten &gt; Weiter
              </li>
              <li> Geben Sie Ihrer Liste einen Namen.</li>
              <li>
                {" "}
                Aktivieren Sie das Kontrollkästchen „Meine Liste anreichern“,
                wenn Sie die beruflichen E-Mail-Adressen Ihrer Kontakte erhalten
                möchten. &gt; Weiter. <br />
              </li>
            </ol>
            <p>
              {" "}
              <b>Hinweis </b>: Das System importiert Ihre Liste, es dauert 20
              Minuten, um 2000 Kontakte zu extrahieren, Sie finden Ihre Liste
              unter „Kontakte“{" "}
            </p>
            <p>
              <b>
                Kontakte extrahieren, die einen Beitrag auf LinkedIn
                kommentiert/geliked haben, indem Sie die folgenden Schritte
                ausführen:
                <br />
              </b>
            </p>
            <ol>
              <li>
                {" "}
                Klicken Sie in LinkedIn, sobald Sie sich auf dem Beitrag Ihrer
                Wahl befinden, auf die 3 kleinen Punkte oben rechts im Beitrag
                und wählen Sie „Link zum Beitrag kopieren“{" "}
              </li>
              <li>
                {" "}
                Wählen Sie in {reseller?.name} unter „Kontakte“ dann „Targeting“
                dann „Suche auf LinkedIn“ die Option „Kontakte extrahieren, die
                einen Beitrag auf LinkedIn kommentiert haben“ oder „Kontakte
                extrahieren, die einen Beitrag auf LinkedIn geliked haben“
              </li>
              <li>
                {" "}
                Fügen Sie den URL-Link in den Abschnitt „LinkedIn-URL der Suche“
                ein.
              </li>
              <li>
                {" "}
                Wählen Sie die Anzahl der zu extrahierenden Profile, die größer
                oder gleich der Anzahl der am Ende Ihrer Suche gefundenen
                Kontakte sein muss &gt; Weiter.{" "}
              </li>
              <li>
                {" "}
                Wählen Sie das LinkedIn-Konto aus, mit dem Sie die Kontakte
                extrahieren möchten. &gt; Weiter.
              </li>
              <li> Geben Sie Ihrer Liste einen Namen &gt; Weiter</li>
              <li>
                {" "}
                Aktivieren Sie das Kontrollkästchen „Meine Liste anreichern“,
                wenn Sie die beruflichen E-Mail-Adressen Ihrer Kontakte erhalten
                möchten.
              </li>
              <li>
                {" "}
                Das System importiert Ihre Liste, Sie finden Ihre Liste unter
                „Kontakte“
                <br />
              </li>
            </ol>
            <p>
              {" "}
              <b>
                Kontakte extrahieren, die mit Ihrem LinkedIn-Netzwerk verbunden
                sind (Stufe 1), indem Sie die folgenden Schritte ausführen:
                <br />
              </b>
            </p>
            <ol>
              <li>
                {" "}
                Wählen Sie in {reseller?.name} unter „Targeting“ dann „Suche auf
                LinkedIn“ die Option „Ihre Verbindungen auf LinkedIn
                extrahieren“
              </li>
              <li> Geben Sie die Anzahl der zu importierenden Profile an </li>
              <li>
                {" "}
                Wählen Sie das LinkedIn-Konto aus, mit dem Sie die Kontakte
                extrahieren möchten. &gt; Weiter
              </li>
              <li> Geben Sie Ihrer Liste einen Namen &gt; Weiter</li>
              <li>
                {" "}
                Aktivieren Sie das Kontrollkästchen „Meine Liste anreichern“,
                wenn Sie die beruflichen E-Mail-Adressen Ihrer Kontakte erhalten
                möchten.
              </li>
              <li>
                {" "}
                Das System importiert Ihre Liste, Sie finden Ihre Liste unter
                „Kontakte“
              </li>
            </ol>
            <p>
              <b>
                Herausgeber von Stellenangeboten auf LinkedIn extrahieren, indem
                Sie die folgenden Schritte ausführen:
                <br />
              </b>
            </p>
            <ol>
              <li>
                {" "}
                Starten Sie Ihre Stellensuche auf LinkedIn, indem Sie „Jobs“ in
                LinkedIn auswählen.
              </li>
              <li> Kopieren Sie den Link Ihrer Suche.</li>
              <li>
                {" "}
                Fügen Sie diesen Link in {reseller?.name} unter „Targeting“ dann
                „Suche auf LinkedIn“ dann „Herausgeber von Stellenangeboten auf
                LinkedIn extrahieren“ ein
              </li>
              <li>
                {" "}
                Wählen Sie die Anzahl der zu extrahierenden Profile, die größer
                oder gleich der Anzahl der am Ende Ihrer Suche gefundenen
                Kontakte sein muss &gt; Weiter.{" "}
              </li>
              <li>
                {" "}
                Wählen Sie das LinkedIn-Konto aus, mit dem Sie die Kontakte
                extrahieren möchten. &gt; Weiter
              </li>
              <li> Geben Sie Ihrer Liste einen Namen &gt; Weiter</li>
              <li>
                {" "}
                Aktivieren Sie das Kontrollkästchen „Meine Liste anreichern“,
                wenn Sie die beruflichen E-Mail-Adressen Ihrer Kontakte erhalten
                möchten.
              </li>
              <li>
                {" "}
                Das System importiert Ihre Liste, Sie finden Ihre Liste unter
                „Kontakte“.
              </li>
            </ol>
          </Stack>
        ),
      },
      {
        url: "import-google",
        title: "Eine Liste aus Google Maps erstellen",
        content: (
          <Stack>
            <p>
              Mit {reseller?.name} können Sie von Ihrem Google-Konto aus
              Kontaktlisten aus einer Suche auf Google Maps erstellen, indem Sie
              die folgenden Schritte ausführen:
            </p>
            <p>
              {" "}
              <br />
              Sie können eine Kontaktliste aus einer Suche auf Google Maps über
              den folgenden Link erstellen:{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists/import/google`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists/import/google
              </a>{" "}
              <br />
              Oder gehen Sie zum Tab „Targeting &gt; Google“
            </p>
            <p>
              <br />
            </p>
            <ol>
              <li>
                Gehen Sie zu Google Maps, um eine Suche durchzuführen, indem Sie
                Ihre Suchelemente eingeben, nämlich die Funktion und den
                geografischen Standort: Beispiel Informatik in Paris.{" "}
                <a
                  href={`https://www.google.com/maps/search/informatique+paris/@48.8592223,2.3418555,13z/data=!3m1!4b1?entry=ttu`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.google.com/maps/search/informatique+paris/@48.8592223,2.3418555,13z/
                </a>{" "}
                <br /> <br />
              </li>
              <li>
                {" "}
                Kopieren Sie in der Suchleiste Ihres Browsers den URL-Link der
                Seite Ihrer Google Maps-Suche. Beispiel:{" "}
                <a
                  href={`https://www.google.com/maps/search/informatique+paris/@48.8592223,2.3418555,13z/data=!3m1!4b1?entry=ttu`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.google.com/maps/search/informatique+paris/@48.8592223,2.3418555,13z/data=!3m1!4b1?entry=ttu
                </a>
                <br />
              </li>
              <li>
                {" "}
                Fügen Sie den URL-Link in {reseller?.name} im Tab „Targeting
                &gt; Google“ ein, um die Ergebnisse einer Suche auf Google Maps
                zu extrahieren.
                <br />
              </li>
              <li>
                Wählen Sie Ihr Google-Konto aus, das Sie konfiguriert haben.{" "}
                <br />
              </li>
              <li>
                {" "}
                Wählen Sie die Anzahl der Ergebnisse / Profile, die extrahiert
                werden sollen.
                <br />
              </li>
              <li>
                {" "}
                Geben Sie Ihrer Liste einen Namen, um sie zu speichern, oder
                wählen Sie den Ordner und eine vorhandene Kontaktliste aus.
                <br />
                Das System importiert Ihre Liste, die Sie im Tab „Kontakte“
                finden.
                <br />
                Sie können auch die Anreicherungsoption „Datenbank außerhalb
                Frankreichs anreichern“ für Ihre Liste aktivieren, um sie mit
                rechtlichen Informationen zu ergänzen und E-Mails für
                ausländische Listen hinzuzufügen <br />
              </li>
            </ol>
          </Stack>
        ),
      },
      {
        url: "import-database",
        title: "Eine Liste aus der Kontaktdatenbank erstellen",
        content: (
          <Stack>
            <p>
              Sie haben auf der Plattform die Möglichkeit, eine Kontaktliste aus
              unserer Datenbank mit mehreren Millionen BtoB-Kontakten zu
              erstellen.
              <br />
            </p>
            <p>
              Um eine Kontaktliste aus unserer Datenbank zu erstellen, klicken
              Sie auf den folgenden Link:{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists/import/base`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists/import/base
              </a>{" "}
              <br />
            </p>
            <p>
              Oder gehen Sie zum Tab <b>Targeting</b>
            </p>
            <ul>
              <li>
                Sie haben somit die Möglichkeit, Ihre Suche zu verfeinern, indem
                Sie weitere Kriterien wie die Funktion, den Tätigkeitsbereich
                und auch die geografische Zone hinzufügen.
              </li>
              <li>
                Sie können Ihre Liste auch filtern, indem Sie den NAF-Code, die
                Tätigkeit des Unternehmens, seinen Umsatz, seine Rechtsform,
                seine Präsenz im Web angeben: Klicken Sie jedes Mal auf den
                blauen Pfeil neben jedem Filter, um Ihre Auswahl hinzuzufügen.
              </li>
            </ul>
            <p>
              <br />
              Um die gefundenen Kontakte in Ihrer Liste zu speichern, klicken
              Sie auf den Button „Speichern“ rechts neben den Profilen, die
              erscheinen.
              <br />
            </p>
            <p>
              <b>Hinweis </b>: Sie haben die Möglichkeit, diese Kontakte zu
              erstellen oder einer bereits erstellten Liste hinzuzufügen.
              <br />
            </p>
            <p>
              Ihre Liste wird somit hinzugefügt, indem Sie auf den folgenden
              Link klicken:{" "}
              <a
                href={`https://{
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists
              </a>{" "}
            </p>
            <p>
              Oder gehen Sie zur Seite <b>Kontakte</b>
            </p>
          </Stack>
        ),
      },
      {
        url: "linkedin-import-not-working",
        title: "Der Import von LinkedIn-Kontakten funktioniert nicht",
        content: (
          <Stack>
            <p>
              Wenn Ihr LinkedIn-Import nicht funktioniert, können Sie diese
              Punkte überprüfen:
            </p>
            <p>
              <br />
              1.Gehen Sie zu{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/senders/linkedin`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /senders/linkedin
              </a>
            </p>
            <p>Oder in „Konfigurationen“ dann „LinkedIn-Konten“ </p>
            <ul>
              <li>
                Überprüfen Sie, ob Ihr Konto noch verbunden ist
                <br />
                Wenn nicht, aktualisieren Sie das Verbindungs-Cookie
                <br />
              </li>
            </ul>
            <p></p>
            <p>
              2. Gehen Sie zu{" "}
              <a
                href={`https://{
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists/import/linkedin`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists/import/linkedin <br />
              </a>
            </p>
            <p>
              Oder in „Targeting“ &gt; „LinkedIn“
              <br />
            </p>
            <ul>
              <li>
                <b>A</b> : Überprüfen Sie, ob der importierte Link mit der Art
                Ihres LinkedIn-Kontos kompatibel ist (ein
                Nicht-Sales-Navigator-Konto kann keinen Sales-Navigator-Link
                importieren)
                <br />
              </li>
            </ul>
            <ul>
              <li>
                <b>B</b> : Überprüfen Sie, ob das Linkformat dem entspricht, das
                vom System bei der Erstellung der Liste angefordert wurde
              </li>
            </ul>
            <p></p>
            <p>
              Wenn Ihr Import immer noch nicht funktioniert, zögern Sie nicht,
              uns zu kontaktieren, wir sind hier, um Ihnen zu helfen!
            </p>
          </Stack>
        ),
      }
    );

    result[5].items.push({
      url: "cname-error",
      title: "CNAME-Fehlermeldungen",
      content: (
        <Stack>
          <p>
            <b>Frage </b>: Ich erhalte diese Fehlermeldung, wenn ich auf meine
            White Label zugreifen möchte
          </p>
          <p>{`{"state":false,"state_message":"action_not_exist","documentation":null}`}</p>
          <p>
            <br />
          </p>
          <p>
            <b>Antwort </b>: Vielleicht haben Sie die Parameter in der Software
            oder in der CNAME-Weiterleitung Ihrer Domain nicht korrekt
            ausgefüllt.
            <br />
            Dieses Problem rührt immer von einem Konfigurationsfehler her.
          </p>
          <p>
            <br />
            <b>Überprüfen Sie die CNAME-Einträge bei Ihrem Domain-Hoster</b>
          </p>
          <ul>
            <li>
              Mail-Subdomain, die in Ihrer CNAME-Domain eingegeben wurde
              <br />
              <br />
              <b>Überprüfen Sie die Parameter in der Software</b>
              <br />
            </li>
            <li>Eingabefehler des Domainnamens in der Software</li>
          </ul>
          <p>
            <br />
          </p>
          <p>
            Überprüfungslösung: Führen Sie <b>nslookup </b>auf Ihrem Computer
            aus
            <br />
            <br />
          </p>
          <p>
            Die Anwendung nslookup ist auf den meisten Betriebssystemen
            verfügbar. <br />
            Sie ermöglicht es, Informationen über Nameserver über eine
            Befehlszeile unter Microsoft Windows, Apple Mac oder Linux zu
            suchen.
            <br />
            <br />
            Um die Befehlszeile unter Windows auszuführen, klicken Sie auf Start
            &gt; Ausführen.
          </p>
          <ul>
            <li>Geben Sie cmd ein und drücken Sie dann die Eingabetaste.</li>
            <li> Unter Mac oder Linux starten Sie das Terminal.</li>
            <li> Geben Sie den folgenden Befehl ein:</li>
            <li>
              {" "}
              nslookup -q=cname{" "}
              <a href={`saas.example.com`} target="_blank" rel="noreferrer">
                saas.example.com
              </a>{" "}
            </li>
            <li>
              {" "}
              Ersetzen Sie{" "}
              <a href={`http://example.com`} target="_blank" rel="noreferrer">
                example.com
              </a>{" "}
              durch den Namen der Domain, die den CNAME-Eintrag enthält, den Sie
              überprüfen möchten.
              <br />
              <br />
            </li>
          </ul>
          <p>
            {" "}
            Interpretieren Sie das Ergebnis wie im folgenden Beispiel,{" "}
            <a href={`example.com`} target="_blank" rel="noreferrer">
              example.com
            </a>{" "}
            :
          </p>
          <p>
            {" "}
            nslookup -q=cname <a href={`saas.exemple.com`}>saas.exemple.com</a>
          </p>
          <p>
            {" "}
            <br />
            Mit diesem Beispiel erhalten wir die folgenden Daten:
          </p>
          <p> Server: box </p>
          <p> Address: 192.168.1.1</p>
          <p> Nicht autorisierende Antwort:</p>
          <p>
            {" "}
            <a href={`saas.exemple.com`} target="_blank" rel="noreferrer">
              saas.exemple.com
            </a>
            canonical name =
            <a
              href={`resellers-pool1.staging.magileads.net`}
              target="_blank"
              rel="noreferrer"
            >
              resellers-pool1.staging.magileads.net
            </a>
            .
          </p>
          <p>
            {" "}
            <br />
            Die gesuchten Informationen befinden sich in den letzten beiden
            Zeilen. <br />
            Genauer gesagt, teilt uns das Ergebnis mit, dass{" "}
            <a href={`saas.exemple.com`} target="_blank" rel="noreferrer">
              saas.exemple.com
            </a>{" "}
            auf den Namen r
            <a
              href={`resellers-pool1.staging.magileads.net.`}
              target="_blank"
              rel="noreferrer"
            >
              esellers-pool1.staging.magileads.net.
            </a>
            zeigt.
          </p>
          <p>
            <br />
          </p>
          <p>
            Sie können Ihre Subdomains auch unter diesem Link testen, wenn Sie
            die IP Ihres Hosters kennen:{" "}
            <a
              href={`https://www.saas-secure.com/online-services/nslookup.html`}
              target="_blank"
              rel="noreferrer"
            >
              https://www.saas-secure.com/online-services/nslookup.html
            </a>
          </p>
          <p>
            <br />
          </p>
          <p></p>
        </Stack>
      ),
    });
  }

  return result;
}
